import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCodigoAfip = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'codigo_afip',
        name: 'Codigo Afip',
        component: ViewCodigoAfip,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
